import React from 'react';
import { Box, Typography } from '@mui/material';
import ProdutoTable from '../components/produto/ProdutoTable';

const Produtos: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Produtos
      </Typography>
      <ProdutoTable />
    </Box>
  );
};

export default Produtos;
